import { buildWebITData } from "@/data/buildWebIT.data";
import { contactData } from "@/data/contact-info.data";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const FacebookLink = () => {
  return (
    <Link
      href={buildWebITData.facebookLink}
      area-label="Facebook"
      target="_blank"
      rel="noopener noreferrer"
    >
      {/* <FaFacebook
                    size={24}
                    className="text-white hover:underline transition-colors duration-300"
                  /> */}
      <Image
        src={contactData[2].src}
        alt="Facebook Icon"
        width={28}
        height={28}
      />
    </Link>
  );
};

export default FacebookLink;
